import React from 'react';
import '../assets/profilePersonalHeader.css';
import { connect } from 'react-redux';
import { PencilLine } from 'lucide-react';
import { ROUTES } from '../constant/Routes';

const ProfilePersonalHeader = ({ firstName, familyName, mobileInfo }) => {
  if (!firstName && !familyName) {
    return (
      <div className='loading-ProfilePersonal'>
        <div className='spinner-border' style={{ width: '1rem', height: '1rem' }}></div>
      </div>
    );
  }
  return (
    <div className='line-ProfilePersonal'>
      <div className='container-ProfilePersonal'>
        <div className='leftSide-ProfilePersonal'>
          <div className='iconContainer-ProfilePersonal'>
            <a href={ROUTES.PERSONAL_INFO}>
              <PencilLine size={16} style={{ color: '#01494b' }} />
            </a>
          </div>
        </div>

        <div className='rightSide-ProfilePersonal'>
          <div className='userName-ProfilePersonal'>{`${firstName} ${familyName}`}</div>
          <div className='phoneNumber-ProfilePersonal'>{mobileInfo}</div>
        </div>
      </div>
    </div>
  );
};
const MapStateToProps = (state) => ({
  firstName: state.user.name,
  familyName: state.user.family,
  mobileInfo: state.user.mobile,
});
export default connect(MapStateToProps)(ProfilePersonalHeader);
